import { FileText, Upload } from 'lucide-react';
import { type ChangeEvent, type DragEvent, useLayoutEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

import { Button } from '~/components/ui/button';
import { cn } from '~/utils/cn';

// ---------------------------------------------------------------------------
// File type icons
// ---------------------------------------------------------------------------

function CsvIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.95675 0H10.7219L10.7352 0.0355858C11.1234 0.392139 11.5844 0.878947 11.9648 1.2592L14.3149 3.60927L15.0619 4.35694C15.1753 4.47031 15.3354 4.64006 15.4507 4.7425C15.5079 4.86025 15.4851 6.46558 15.4851 6.68267L15.4851 10.0465L15.4849 12.6712C15.4849 13.0968 15.4987 13.6238 15.4813 14.0437C15.4729 14.2445 15.4356 14.443 15.3705 14.6332C15.1717 15.2107 14.6834 15.7105 14.101 15.8959C14.0492 15.9125 13.814 15.9789 13.7815 16H4.94368C4.86701 15.9644 4.6109 15.8967 4.49792 15.852C4.08709 15.6889 3.70562 15.3482 3.49032 14.9652C3.37376 14.7537 3.29542 14.5233 3.2589 14.2845C3.219 14.0274 3.18779 11.9524 3.24509 11.7499C3.24043 11.7502 3.23579 11.7505 3.23114 11.7508C2.55429 11.7541 1.87731 11.7532 1.20046 11.7534C1.12769 11.7534 1.05383 11.75 0.985793 11.7449C0.587402 11.7152 0.506369 11.477 0.51876 11.1201C0.517061 10.237 0.517132 9.35659 0.517376 8.47481L0.517774 7.67936C0.518007 7.41645 0.476115 6.98122 0.751746 6.86737C0.966683 6.77861 1.49083 6.80698 1.72798 6.80702L3.23078 6.81086C3.215 6.65611 3.22462 6.27739 3.22462 6.10945L3.22473 4.74002L3.224 2.99595C3.22364 2.66567 3.21254 2.24559 3.23615 1.92273C3.24942 1.71911 3.29117 1.51837 3.36018 1.32636C3.55932 0.784742 3.9784 0.352723 4.51371 0.137221C4.65009 0.0824173 4.84739 0.0550845 4.95675 0Z"
        fill="#00743B"
      />
      <path
        d="M3.24509 11.7519C3.24043 11.7522 3.23579 11.7525 3.23114 11.7528C2.55429 11.7561 1.87731 11.7552 1.20046 11.7554C1.12769 11.7554 1.05383 11.752 0.985793 11.7469C0.587402 11.7172 0.506369 11.479 0.51876 11.1221C0.517061 10.2391 0.517132 9.35861 0.517376 8.47682L0.517774 7.68137C0.518007 7.41847 0.476115 6.98323 0.751746 6.86939C0.966683 6.78062 1.49083 6.809 1.72798 6.80903L3.23078 6.81287C3.98371 6.81803 4.73668 6.81928 5.48964 6.81664L9.41232 6.81661L11.0779 6.81592C11.4039 6.81559 11.7379 6.80878 12.0623 6.83048C12.5298 6.86173 12.4419 7.49895 12.441 7.83056L12.438 8.87192L12.4399 10.4176C12.44 10.6814 12.4403 10.9468 12.4369 11.2087C12.4334 11.482 12.3365 11.7157 12.0306 11.7386C11.7432 11.76 11.4488 11.7515 11.1605 11.7509L9.70009 11.7492L5.42279 11.7498C4.7482 11.7498 3.9069 11.725 3.24509 11.7519Z"
        fill="#005D2F"
      />
      <path
        d="M6.18859 7.64807C6.5497 7.62402 6.93439 7.59694 7.22983 7.83473C7.47359 8.03091 7.73928 8.67296 7.23486 8.72319C6.99874 8.74671 7.02295 8.32193 6.88641 8.21952C6.73652 8.11759 6.41677 8.16101 6.23714 8.16449C6.13064 8.16888 6.01077 8.24179 5.948 8.32619C5.86502 8.43776 5.84413 8.56998 5.86353 8.7058C5.91808 9.08751 6.49881 8.99115 6.76419 9.04283C6.88334 9.06604 7.03236 9.13819 7.13092 9.20998C7.33609 9.36002 7.47225 9.58632 7.5087 9.83787C7.58908 10.3816 7.20808 10.8396 6.67583 10.9164C6.34592 10.9504 5.87584 10.9561 5.62063 10.7255C5.46267 10.5828 5.3568 10.3831 5.33775 10.1691C5.32084 9.97907 5.42286 9.85538 5.61508 9.84455C5.88053 9.84174 5.82234 10.2196 5.96736 10.3408C6.10025 10.4518 6.4413 10.3962 6.61203 10.4044C6.71569 10.4093 6.85539 10.3014 6.91519 10.2265C6.98624 10.1376 7.01128 10.0061 6.99272 9.89396C6.91483 9.48488 6.46909 9.55702 6.16055 9.50841C5.74053 9.43941 5.41222 9.21576 5.3503 8.76624C5.27206 8.19841 5.61499 7.72441 6.18859 7.64807Z"
        fill="#FEFEFE"
      />
      <path
        d="M3.68094 7.64221C4.20363 7.56736 4.73857 7.94889 4.85748 8.46205C4.90118 8.65064 4.93901 8.92344 4.68151 8.97913C4.4041 9.03913 4.37926 8.73742 4.3399 8.55871C4.2533 8.08133 3.48591 8.02066 3.31054 8.4361C3.19038 8.72074 3.1671 9.94797 3.3449 10.1761C3.61357 10.5209 4.1248 10.4671 4.33362 10.0338C4.36102 9.93085 4.37307 9.75311 4.42712 9.67477C4.55474 9.4898 4.87146 9.56628 4.88721 9.80325C4.90335 10.0458 4.81351 10.2879 4.6754 10.4747C4.50238 10.7085 4.24374 10.8643 3.95613 10.9077C3.66746 10.9475 3.37473 10.8722 3.14101 10.6982C2.8428 10.4748 2.68746 10.0929 2.71012 9.72441C2.73323 9.34836 2.66221 8.83717 2.74287 8.47775C2.77673 8.32746 2.84204 8.18603 2.93449 8.06278C3.12052 7.81541 3.37852 7.68461 3.68094 7.64221Z"
        fill="#FEFEFE"
      />
      <path
        d="M8.09788 7.64139C8.22363 7.63592 8.34147 7.65736 8.39155 7.78879C8.64983 8.46678 8.84347 9.17229 9.094 9.85364C9.10182 9.81818 9.11033 9.78289 9.11957 9.74776C9.28538 9.12678 9.56467 8.45126 9.75413 7.83023C9.76755 7.7862 9.83032 7.68433 9.87738 7.67093C10.5432 7.48148 10.1067 8.41307 10.018 8.67314L9.56963 10.0278C9.5015 10.2332 9.3623 10.7009 9.26232 10.8634C8.86638 11.0868 8.79974 10.6354 8.70782 10.3595L8.45128 9.58851L8.10183 8.53595C8.04428 8.36231 7.95153 8.10807 7.91269 7.93895C7.90233 7.89557 7.9045 7.85015 7.91896 7.80795C7.94836 7.72125 8.02157 7.68017 8.09788 7.64139Z"
        fill="#FEFEFE"
      />
      <path
        d="M10.733 0.0390625C11.1212 0.395616 11.5822 0.882424 11.9626 1.26268L14.3127 3.61274L15.0597 4.36041C15.1731 4.47379 15.3332 4.64354 15.4485 4.74598C15.3238 4.80321 15.0044 4.78523 14.8527 4.78534L13.7735 4.78535L12.0626 4.78632C11.7684 4.78635 11.4686 4.79052 11.1745 4.78034C11.0773 4.77476 10.9786 4.7424 10.8986 4.68824C10.6235 4.50191 10.6858 4.05743 10.6856 3.75599L10.6859 2.73638L10.6858 1.1299C10.6859 0.953608 10.664 0.13519 10.733 0.0390625Z"
        fill="#005D2F"
      />
    </svg>
  );
}

function TsvIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.01837 0H10.7148L10.7205 0.0357705C11.1301 0.409272 11.5822 0.884542 11.978 1.28034L14.2578 3.56159L15.0364 4.33991C15.1412 4.44427 15.3258 4.63742 15.4325 4.73023C15.4747 4.79689 15.4713 4.86566 15.472 4.94414C15.4784 5.6887 15.4754 6.43519 15.475 7.17978L15.4741 11.2398L15.4746 13.1064C15.4747 13.5132 15.5048 14.0413 15.424 14.4289C15.278 15.1291 14.6856 15.732 14.0025 15.9248C13.9128 15.9502 13.7777 15.9606 13.6984 16H4.99395C4.44909 15.8242 4.14112 15.7647 3.7308 15.289C3.52853 15.0581 3.38417 14.7823 3.3097 14.4845C3.21187 14.0916 3.24611 13.3997 3.24267 12.9704C3.23984 12.6148 3.23115 12.0929 3.25597 11.7473C2.62892 11.7373 2.00445 11.747 1.37795 11.7432C1.01238 11.7409 0.557648 11.7929 0.537309 11.2962C0.527642 11.0601 0.532023 10.8191 0.532231 10.5803L0.533854 9.30075C0.534019 8.95903 0.498303 7.32152 0.558205 7.12727C0.59049 7.02258 0.662431 6.92047 0.764647 6.87477C1.11247 6.71927 3.10095 6.88627 3.22776 6.80775C3.23211 6.80506 3.2362 6.80202 3.24042 6.79916C3.23019 6.52408 3.24145 6.17134 3.24165 5.8885L3.24289 3.97603L3.23984 2.64577C3.2393 2.41605 3.23003 2.10184 3.24756 1.87831C3.26409 1.67998 3.30856 1.48498 3.37967 1.29909C3.63025 0.648881 4.20301 0.174063 4.88425 0.0420613C4.9327 0.0326714 4.97362 0.021615 5.01837 0Z"
        fill="#40198B"
      />
      <path
        d="M3.24042 6.79688C3.27987 6.82217 9.47637 6.81241 10.1671 6.81189L11.3299 6.81078C11.611 6.81067 12.3087 6.72967 12.3976 7.0855C12.4642 7.35211 12.4405 7.74534 12.4401 8.0282L12.438 9.33775L12.4396 10.5511C12.44 10.8393 12.474 11.2622 12.3661 11.536C12.3427 11.5955 12.2 11.7027 12.1327 11.7177C11.8193 11.7633 11.4738 11.7475 11.1565 11.7474L9.66373 11.7466L3.25597 11.745C2.62892 11.735 2.00445 11.7448 1.37795 11.7409C1.01238 11.7387 0.557648 11.7907 0.537309 11.2939C0.527642 11.0578 0.532023 10.8168 0.532231 10.578L0.533854 9.29847C0.534019 8.95675 0.498303 7.31923 0.558205 7.12498C0.59049 7.0203 0.662431 6.91819 0.764647 6.87248C1.11247 6.71698 3.10095 6.88398 3.22776 6.80547C3.23211 6.80278 3.2362 6.79973 3.24042 6.79688Z"
        fill="#2C0C5F"
      />
      <path
        d="M6.17949 7.64356C6.46046 7.60273 6.92485 7.62018 7.17135 7.78885C7.3449 7.90645 7.46315 8.08957 7.4989 8.29615C7.54005 8.53051 7.4392 8.81891 7.16646 8.69354C6.91196 8.57654 7.04466 8.34413 6.87823 8.21832C6.74324 8.11629 6.3847 8.15837 6.21768 8.16395C6.09173 8.1811 6.00215 8.2504 5.92746 8.34899C5.84995 8.45132 5.83701 8.58093 5.86129 8.70495C5.93584 9.08587 6.4633 8.97956 6.74054 9.03574C6.87362 9.06271 7.00132 9.11971 7.11316 9.1976C7.32041 9.34107 7.46088 9.56221 7.50266 9.81081C7.54423 10.0646 7.48305 10.3245 7.33268 10.5331C7.16745 10.7597 6.92699 10.8749 6.65612 10.9167C6.35304 10.9329 5.98193 10.9554 5.70832 10.7892C5.45057 10.6326 5.12424 10.061 5.49504 9.86512C5.83448 9.66162 5.84073 10.2841 5.96998 10.3374C6.31402 10.479 7.07335 10.4701 6.99285 9.90682C6.92046 9.4852 6.45923 9.54635 6.15246 9.50476C5.00993 9.34982 5.09196 7.80166 6.17949 7.64356Z"
        fill="#FEFEFE"
      />
      <path
        d="M8.09714 7.64372C8.31007 7.62775 8.36549 7.69636 8.43535 7.89103C8.50727 8.09145 8.57114 8.29559 8.63774 8.49789L9.08771 9.85212C9.17902 9.52504 9.30278 9.19134 9.40616 8.86708C9.51871 8.51401 9.6343 8.15665 9.76477 7.81051C9.86763 7.53758 10.2467 7.61387 10.2581 7.89453C10.2354 8.09262 10.0928 8.45922 10.024 8.66061L9.56102 10.0563C9.50925 10.2132 9.34355 10.8252 9.21363 10.8896C8.86344 11.0632 8.78 10.5925 8.70296 10.3595L8.46364 9.6327L8.11903 8.59444C8.05528 8.40211 7.98883 8.21133 7.93291 8.01651C7.8736 7.80986 7.90694 7.73667 8.09714 7.64372Z"
        fill="#FEFEFE"
      />
      <path
        d="M2.93211 7.64828L4.13233 7.64477C4.26373 7.64469 4.84556 7.61497 4.90969 7.71589C5.26566 8.27619 4.41467 8.16319 4.12267 8.1603C4.10305 8.84217 4.11917 9.59691 4.11995 10.2833C4.12008 10.4965 4.18108 10.918 3.87402 10.9234C3.80033 10.9247 3.72922 10.8963 3.67675 10.8445C3.64009 10.8087 3.61033 10.7534 3.6065 10.7028C3.58637 10.4361 3.59552 10.1424 3.59592 9.87439L3.59762 8.16017C3.38916 8.16319 3.03586 8.19256 2.85353 8.1222C2.61391 8.02975 2.70097 7.72752 2.93211 7.64828Z"
        fill="#FEFEFE"
      />
      <path
        d="M10.7205 0.0390625C11.1301 0.412564 11.5822 0.887834 11.9781 1.28364L14.2578 3.56489L15.0364 4.3432C15.1412 4.44756 15.3259 4.64071 15.4326 4.73353C15.3625 4.77534 15.3246 4.78046 15.2431 4.7814C14.5637 4.78914 13.8839 4.78207 13.2043 4.7827L11.9199 4.78425C11.6517 4.78454 11.277 4.81029 11.0129 4.74223C10.9243 4.70837 10.7749 4.56746 10.7467 4.48226C10.6556 4.20681 10.6879 3.78268 10.6877 3.49257L10.6874 2.19423C10.6874 1.90078 10.6557 0.232036 10.7205 0.0390625Z"
        fill="#2C0C5F"
      />
    </svg>
  );
}

/** Formats a byte count to a human-readable size string, e.g. "2.8 MB" or "512 KB". */
function formatFileSize(bytes: number): string {
  if (bytes >= 1_048_576) return `${(bytes / 1_048_576).toFixed(1)} MB`;
  return `${(bytes / 1024).toFixed(1)} KB`;
}

/** Returns the thumbnail icon element for a given file name, keyed by extension. */
function getFileIcon(fileName: string) {
  const ext = fileName.split('.').pop()?.toLowerCase();
  if (ext === 'csv') {
    return (
      <div className="bg-success-50 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg">
        <CsvIcon />
      </div>
    );
  }
  if (ext === 'tsv') {
    return (
      <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-purple-50">
        <TsvIcon />
      </div>
    );
  }
  return (
    <div className="bg-error-50 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg">
      <FileText className="text-destructive h-4 w-4" />
    </div>
  );
}

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

export interface UploadedFile {
  id: string;
  name: string;
  /** Human-readable upload timestamp, e.g. "Uploaded June 23, 2026". */
  uploadedAt: string;
  /** Raw file size in bytes — formatted and displayed below the filename. */
  sizeBytes: number;
}

interface FileUploadProps {
  /** Maximum allowed file size in megabytes — validated on selection and drop. */
  allowedSizeMb: number;
  /** File extensions to accept, e.g. ['.csv', '.pdf']. Drives the input accept attribute and the auto-generated hint text. */
  allowedFileTypes: string[];
  /** Maximum number of files the user can upload. Defaults to 1. The drop zone hides once the limit is reached. */
  maxUploads?: number;
  /** Called whenever the uploaded file list changes (add or remove). */
  onChange?: (files: UploadedFile[]) => void;
  /** Called with the raw File object on each selection or drop — useful when the parent needs to call an API with the file itself. */
  onFileSelect?: (file: File) => void;
  /** Called with the raw File objects whenever the list changes — use when the caller needs the actual File for an upload. */
  onRawChange?: (files: File[]) => void;
  /** Whether to render the internal uploaded-files list. Set false when the parent renders its own file display. Defaults to true. */
  showFileList?: boolean;
  /**
   * Files to pre-populate on mount — use when the parent restores a previously
   * selected file after a back-navigation. Evaluated once on first render only.
   */
  initialFiles?: File[];
  /**
   * Optional async validator run after the size check and before a file is
   * accepted. Return an error message to reject the file or null/undefined to
   * accept it. The message is shown as a toast unless `onValidationError` is set.
   */
  validateFile?: (file: File) => Promise<string | null> | string | null;
  /**
   * Called with the `validateFile` rejection message. When provided, the message
   * is surfaced through this callback (e.g. so the parent can render an inline
   * banner) instead of a toast. Omit to keep the default toast behaviour.
   */
  onValidationError?: (message: string) => void;
  /** Automation hook (default `file-upload`); derives dropzone, browse, input and per-file ids. */
  testId?: string;
}

// ---------------------------------------------------------------------------
// FileUpload
// ---------------------------------------------------------------------------

/**
 * Drag-and-drop file upload zone with an uploaded-files list, per-file size
 * validation, and a configurable upload count limit.
 * Manages its own file list state; call onChange / onRawChange to sync with the parent.
 */
export function FileUpload({
  allowedSizeMb,
  allowedFileTypes,
  maxUploads = 1,
  onChange,
  onFileSelect,
  onRawChange,
  showFileList = true,
  initialFiles,
  validateFile,
  onValidationError,
  testId = 'file-upload',
}: FileUploadProps) {
  const { t } = useTranslation('common');
  const inputRef = useRef<HTMLInputElement>(null);
  // Parallel map keeps raw File references keyed by the UploadedFile id.
  const rawFilesRef = useRef(new Map<string, File>());
  const [uploadedFiles, setUploadedFiles] = useState<UploadedFile[]>([]);
  const [isDragging, setIsDragging] = useState(false);

  // Seed the file list and rawFilesRef from initialFiles on first mount.
  // useLayoutEffect runs synchronously before the browser paints so there is no
  // visible flash of empty state; ref access inside effects is safe per React rules.
  useLayoutEffect(() => {
    if (!initialFiles?.length) return;
    const date = new Date().toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    });
    const seeded: UploadedFile[] = initialFiles.map((file) => {
      const id = crypto.randomUUID();
      rawFilesRef.current.set(id, file);
      return {
        id,
        name: file.name,
        uploadedAt: t('fileUpload.uploadedAt', { date }),
        sizeBytes: file.size,
      };
    });
    setUploadedFiles(seeded);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // intentionally empty — seed runs once on mount only

  const accept = allowedFileTypes.join(',');
  const typeList = allowedFileTypes.map((ext) => ext.replace(/^\./, '').toUpperCase()).join(', ');
  const isAtLimit = uploadedFiles.length >= maxUploads;
  // The picker is either shown-and-usable or hidden — never shown-but-disabled. It
  // hides at the limit ONLY when we render the internal list, whose remove button is
  // the way back. When the parent owns the list (`showFileList={false}`) it owns
  // add/remove/replace, so the picker stays live regardless of the internal count —
  // otherwise a file the parent rejected would wedge it with no remove button to
  // clear it (disabled Browse, inert drop zone).
  const showDropzone = !isAtLimit || !showFileList;

  const addFile = async (file: File) => {
    if (file.size > allowedSizeMb * 1024 * 1024) {
      toast.error(t('fileUpload.errors.tooLarge', { size: allowedSizeMb }));
      return;
    }
    // Caller-supplied validation (e.g. row-count limits) — rejects before the
    // file is added to the list, matching the size-error behaviour above.
    if (validateFile) {
      const error = await validateFile(file);
      if (error) {
        // Surface via the parent (inline banner) when wired, else toast.
        if (onValidationError) {
          onValidationError(error);
        } else {
          toast.error(error);
        }
        return;
      }
    }
    onFileSelect?.(file);
    const date = new Date().toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    });
    const id = crypto.randomUUID();
    rawFilesRef.current.set(id, file);
    const newFiles: UploadedFile[] = [
      ...uploadedFiles,
      {
        id,
        name: file.name,
        uploadedAt: t('fileUpload.uploadedAt', { date }),
        sizeBytes: file.size,
      },
    ];
    setUploadedFiles(newFiles);
    onChange?.(newFiles);
    onRawChange?.(Array.from(rawFilesRef.current.values()));
  };

  const removeFile = (id: string) => {
    rawFilesRef.current.delete(id);
    const newFiles = uploadedFiles.filter((f) => f.id !== id);
    setUploadedFiles(newFiles);
    onChange?.(newFiles);
    onRawChange?.(Array.from(rawFilesRef.current.values()));
  };

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    // The input is only mounted while the picker is usable, so no limit guard is
    // needed here; `addFile` re-runs the size/validation checks regardless.
    const file = e.target.files?.[0];
    if (file) void addFile(file);
    // Always reset so the same file can be re-selected after removal.
    if (inputRef.current) inputRef.current.value = '';
  };

  const handleDrop = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    if (file) void addFile(file);
  };

  const handleDragOver = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e: DragEvent<HTMLDivElement>) => {
    // Only clear drag state when leaving the container itself, not a child.
    if (!e.currentTarget.contains(e.relatedTarget as Node)) {
      setIsDragging(false);
    }
  };

  return (
    <div className="flex flex-col gap-4" data-testid={testId}>
      {/* Drop zone + browse button — hidden once a file is selected (at the upload
          limit) while the internal list is shown, so the list's remove button is
          the way back. Stays visible for parent-managed lists (showFileList=false). */}
      {showDropzone && (
        <div className="bg-background flex flex-col rounded-2xl shadow-xl">
          <div
            role="button"
            tabIndex={0}
            aria-label={t('fileUpload.dropzone.title')}
            data-testid={`${testId}-dropzone`}
            onClick={() => {
              inputRef.current?.click();
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') inputRef.current?.click();
            }}
            onDrop={handleDrop}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            className={cn(
              'border-border bg-background flex cursor-pointer flex-col items-center justify-center gap-2 rounded-t-xl border border-dashed px-4 py-8 transition-colors',
              isDragging ? 'border-primary/60 bg-primary/5' : 'hover:bg-surface-subtle',
            )}
          >
            <div className="bg-muted flex h-10 w-10 items-center justify-center rounded-xl">
              <Upload className="text-muted-foreground h-5 w-5" />
            </div>
            <p className="text-foreground text-sm font-medium">{t('fileUpload.dropzone.title')}</p>
            <p className="text-muted-foreground text-xs">
              {t('fileUpload.dropzone.hint', { types: typeList, size: allowedSizeMb })}
            </p>
          </div>

          <div className="bg-surface-subtle flex justify-center rounded-b-xl px-4 py-3">
            <Button
              variant="outline"
              className="cursor-pointer gap-2"
              data-testid={`${testId}-browse-button`}
              onClick={() => {
                inputRef.current?.click();
              }}
            >
              <Upload className="h-4 w-4" />
              {t('fileUpload.browse')}
            </Button>
            <input
              ref={inputRef}
              type="file"
              accept={accept}
              className="hidden"
              data-testid={`${testId}-input`}
              onChange={handleInputChange}
            />
          </div>
        </div>
      )}

      {/* Uploaded files list — suppressed when parent renders its own display */}
      {showFileList && uploadedFiles.length > 0 && (
        <div
          className="bg-background flex flex-col gap-3 rounded-xl"
          data-testid={`${testId}-file-list`}
        >
          {uploadedFiles.map((file) => (
            <div
              key={file.id}
              className="border-border flex items-center gap-3 rounded-xl border px-4 py-3"
              data-testid={`${testId}-file-${file.name}`}
            >
              {getFileIcon(file.name)}
              <div className="flex flex-1 flex-col">
                <p
                  className="text-foreground text-sm font-medium"
                  data-testid={`${testId}-file-${file.name}-name`}
                >
                  {file.name}
                </p>
                <p
                  className="text-muted-foreground text-xs"
                  data-testid={`${testId}-file-${file.name}-size`}
                >
                  {formatFileSize(file.sizeBytes)}
                </p>
              </div>
              <Button
                variant="ghost"
                size="sm"
                className="hover:bg-brand-50 text-destructive hover:text-destructive border-brand-50 cursor-pointer border"
                data-testid={`${testId}-file-${file.name}-remove-button`}
                onClick={() => {
                  removeFile(file.id);
                }}
              >
                {t('fileUpload.remove')}
              </Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
